<div mat-dialog-title class="m-t-16 flex flex-row gap-4 p-6">
  <button mat-raised-button type="button" (click)="cancel()">Close</button>
</div>

<mat-dialog-content>
  <app-payment-notice [canPay]="true" [entityType]="data.entityType" [feeType]="data.feeType"  [id]="data.id" [amount]="data.amount" class="p-6"></app-payment-notice>
</mat-dialog-content>
